import { Component } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MainService } from './providers/mainService.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  constructor(private router: Router, public fb: FormBuilder,private service: MainService) {
    console.log('anshul');
    window.addEventListener('offline', function(event){
      console.log('You lost connection.');
  });

  window.addEventListener('online', function(event){
      console.log('You are now back online.');
  });
    router.events.subscribe( (event: Event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    this.productListApi()
  }

  productListApi() {
   
   let url = `staticPara/getSaticParaList`
    this.service.getApi(url, 0).subscribe(response => {
      if (response.responseCode == 200) {
       localStorage.setItem('para', JSON.stringify(response.result))
      }
    })
  }

  // myForm = this.fb.group({
  //   companies: this.fb.array([])
  // })


}


// WEBPACK FOOTER //
// /Users/tanveer/Documents/sportsYala_New/sportswebmobplatform-18023153-angular4/src/app/app.component.ts